import { render, staticRenderFns } from "./AppFileDragAndDrop.vue?vue&type=template&id=d7efa920&scoped=true&"
import script from "./AppFileDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./AppFileDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./AppFileDragAndDrop.vue?vue&type=style&index=0&id=d7efa920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7efa920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardText,VIcon,VOverlay})
